<template>
  <div class="footer">
    <div class="footer_item">
      <div class="footer_item_left">
        <div class="tit">
          <a @click="$router.push('/')">首页</a><span>|</span>
          <a @click="$router.push('/product')">融创产品</a><span>|</span>
          <a @click="$router.push('/system')">系统方案</a><span>|</span>
          <a @click="$router.push('/about')">关于我们</a><span>|</span>
          <a @click="$router.push('/connection')">联系我们</a>
        </div>
        <!-- <p class="tel">Tel-400-855-7908</p> -->
        <div class="info">
          <!--400-855-7908 &nbsp;&nbsp;&nbsp;  -->
          <p>咨询电话：15210807987 彭先生（微信同号）</p>
          <p>联系邮箱：bjdzhljy@163.com</p>
          <!-- <p>办公时间：周一至周五  8：50am-6:00pm</p> -->
          <!-- <p>办公地址：北京市北京经济技术开发区天华北街11号院1号楼13层1302-2室</p> -->
          <p>办公地址：北京市通州区新华东街126号1幢2层B20</p> 
          <!-- <p>办公电话：400-855-7908</p> -->
           <p></p>
           <div class="txt"> 友情链接：
            <a target="_blank" href="https://bjdzhljy.com/"> 汇领云学</a>&nbsp;&nbsp;
            <a target="_blank" href="http://www.moe.gov.cn/">教育部网站</a>&nbsp;&nbsp;
            <a target="_blank" href="https://www.smartedu.cn/"> 中国智慧高教平台</a>&nbsp;&nbsp;
            <a target="_blank" href="https://vocational.smartedu.cn/"> 中国智慧职教平台</a>
          </div>
        </div>
      </div>
      <div class="footer_item_right">
        <img src="@/assets/imgs/3149b24c9f86d2ea097fb71d2681c78@2x.png" alt="" class="wxgz">
        <p class="wxgztit">关注微信公众号</p>
      </div>
    </div> 
    <div class="copy">
      <a>&copy;2026 北京大智汇领科技有限公司 版权所有</a> <span> |</span>
      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802039921" style="text-align: center;">
        <img src="@/assets/imgs/footer_ygab_icon.png" alt="" class="ban">
        <font color="white">公安备案11010802039921号</font>
      </a > &nbsp;
      <a target="_blank" href="https://beian.miit.gov.cn/"  ><font color="white">京ICP备20006419-5号</font></a >
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{

    }
  },
  methods:{

  }
}
</script>
<style lang="scss" scoped>
.footer{
  width: 100%;
  // height: 320px;
  background: #091430;
  &_item{
    overflow: hidden;
    padding: 50px 0 39px;
    margin: auto;
    width: 1200px;
    min-width: 1200px;
    display: flex;
    justify-content: space-between;
    &_left{
      .tit{
        font-size: 16px;
        color: #ffffff;
        a{
          width: 32px;
          height: 21px;
          font-size: 16px;
          font-family: Microsoft YaHei, Microsoft YaHei-Regular;
          font-weight: 400;
          text-align: left;
          color: #ffffff;
        }
        span{
          width: 2px;
          margin: 0 20px;
        }
      }
      .tel{
        width: 206px;
        height: 31px;
        font-size: 24px;
        font-family: Microsoft YaHei, Microsoft YaHei-Regular;
        font-weight: 400;
        text-align: left;
        color: #ffffff;
        margin: 34px 0 20px;
      }
      .info{
        overflow: hidden;
        margin-top: 54px;
        .txt{
          // height: 19px;
          font-size: 14px;
          font-family: Microsoft YaHei, Microsoft YaHei-Regular;
          font-weight: 400;
          text-align: left;
          color: #d8d8d8;
          // margin-top: 10px;
          // line-height: 20px;
          a{
            font-size: 14px;
            font-family: Microsoft YaHei, Microsoft YaHei-Regular;
            font-weight: 400;
            color: #d8d8d8;
          }
        }
        p{
          height: 19px;
          font-size: 14px;
          font-family: Microsoft YaHei, Microsoft YaHei-Regular;
          font-weight: 400;
          text-align: left;
          color: #d8d8d8;
          margin-top: 10px;
          line-height: 20px;
          &:first-child{
            margin: 0;
          }
        }
      }
    }
    &_right{
      // display: flex;
      // flex-direction: column;
      // justify-content: center;
      // align-items: center;
      .wxgz{
        margin-top: 28px;
        width: 122px;
        height: 122px;
        background: rgba(0,0,0,0.00);
        border-radius: 6px;
      }
      .wxgztit{
        // width: 84px;
        height: 16px;
        font-size: 12px;
        font-family: Microsoft YaHei, Microsoft YaHei-Regular;
        font-weight: 400;
        text-align: center;
        color: #d8d8d8;
        margin: 11px 0 0;
      }
      
    }
  }
  .copy{
    width:100%;
    height: 50px;
    background: #1d2539;
    text-align: center;
    line-height: 50px;
    a{
      width: 168px;
      height: 16px;
      font-size: 12px;
      font-family: Microsoft YaHei, Microsoft YaHei-Regular;
      font-weight: 400;
      text-align: left;
      color: #d8d8d8;
    }
    span{
      width: 1px;
      height: 8px;
      color: #d8d8d8;
      margin: 0 12px;
    }
  }
}
.ban{
  width: 16px;
  height: 18px;
  display: inline-block;
  margin: 0 4px 6px 0;
  vertical-align: middle;
}
</style>